import React, { Component } from 'react';
import {
  UncontrolledTooltip,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table
} from "reactstrap";
import { fetchData } from "../common/networkRequests";
import { async } from 'q';


class GenerateScheduleCustom extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
          ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
          ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)) + 1,
          extraClass: "",
          errorMessage: "",
          modal: false,
          boxClass: "",
              
    
        };
      }

      getScheduleData = async ({ value}) => {
        let {
          currentPage,
          alerts,
          formElements,
          notifications,remoteip
        } = this.props.parentState;
        console.log(this.props);
        if (value && value != '') {
          let { token } = this.props.parentProps.parentState;
          let { dataType, sendData } = this.props.component.sendToServer;
          let { placeHolder } = this.props.component;
          let CBSurl = `${remoteip}/sentry`;
          let url = CBSurl;
          let method = 'post';
    
          let saveThis = { dataType, value, dependantOnValues: sendData && this.generateOtherValues(sendData), currentPage };
          // start animation
          this.setState({ boxClass: "BorderBottom" });
          let { results, exceptions, vendorErrors, error } = await fetchData({ url, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
          if (vendorErrors.length > 0) {
            notifications = { value: "Can not connect to the main server: " + vendorErrors[0], alertType: "warning" };
            this.props.liftGlobalState({ name: 'notifications' }, notifications);
          }
          else if (error) {
            
            this.setErrorMessages("Can not connect to the main server");
            notifications = { value: "Can not connect to the main server", alertType: "warning" };
            this.props.liftGlobalState({ name: 'notifications' }, notifications);
          } else {
            // stop animation
            this.setState({ boxClass: "" })
    
            let { displayData, requiredKey } = this.props.component;
    
            if (Object.keys(results).length == 0 || !results[requiredKey] || Object.keys(exceptions).length != 0) {
              let errorM = exceptions.message && exceptions.message.indexOf('Exception') != -1 ? `Error Occured in ${placeHolder}` : exceptions.message;
    
              this.setErrorMessages(errorM);
              alerts.unshift({ value: errorM, alertType: "warning" });
              for (var key in displayData) {
                this.props.liftState({ "name": displayData[key] }, '');
              }
            } else {
              for (var key in displayData) {
    
                this.props.liftGlobalState({ name: "alerts" }, []);
    
                this.props.liftState({ "name": displayData[key] }, results[key]);
              }
            }
            this.props.liftGlobalState({ name: 'notifications' }, []);
          }
        }
      }   


    handleBlur = async (e) => {
        // console.log("HANDLE BLUR");
        // debugger;
        let { isReadOnly } = this.props.component;
        let { formState } = this.props.parentState;
        if (formState != 'edit' || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit')) {
        } else {
          this.getScheduleData({ value: e.target.value});
        }   
    
    }

    handleFocus = async (e) => {
        let { displayData, isReadOnly } = this.props.component;
    
        let datas = { keys: [], values: [] };
    
        let { formState } = this.props.parentState;
        if (formState != 'edit' || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit')) {
        } else {
          for (var key in displayData) {
            datas.keys.push({ "name": displayData[key] });
            datas.values.push('');
          }
          this.props.liftState(datas.keys, datas.values);
        }
    }

      generateID() {
        return this.state.ttid;
      }
    
      generateID2() {
        return this.state.ttid2;
      }

    render() {
        const {
            name,            
            placeHolder,
            isRequired,
            description,
            focus,
            disabled,
            isReadOnly,
            displayData
          } = this.props.component;
      
          let { pageData, fileFolder } = this.props.parentState;
          let { currentPage, formElements, formState } = this.props.parentState;
          let isReadOnly1 = false;
          if (( formState != 'edit' && fileFolder.isOpen) || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit' && fileFolder.isOpen)) {
            isReadOnly1 = true;
          }
         
          let boxvalue = pageData[name]
            ? pageData[name]
            : "";
          let textType = "number";
      
          if (this.props.component.textType) {
            textType = this.props.component.textType;
          }

          const tooltipID = this.generateID();
          const tooltipID2 = this.generateID2();

        return (
            <div className={`form-group ${this.props.component.widths.parent} `}>
             <input
            autocomplete="off"
            id={tooltipID2}
            style={this.state.boxClass != "" ? { border: "1px solid green" } : null}
            className={`col-12 form-control form-control-sm primary ${
              this.props.parentState.errorMessages != undefined &&
                this.props.parentState.errorMessages[name]
                ? "validationErrorBox"
                : ""
              }`}
            required={isRequired}
            readOnly={isReadOnly1}
            type={textType}
            name={name}
            placeholder={placeHolder}
            value={boxvalue}
            onChange={this.handleChange}
            autoFocus={focus ? true : false}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            // onKeyUp={e => this.showModal(e)}
          />

             />
            </div>
        );
    }
}

export default GenerateScheduleCustom;